import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Select, InputNumber, DatePicker, Icon } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import ExportFixedLine from './ExportFixedLine';
import { saveJdeCode } from '../../../actions/investigationActions';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const InputGroup = Input.Group;
const Option = Select.Option;
const { MonthPicker } = DatePicker;
const GlobalTypeList = [
    { label: '全球多中心', value: 'Global_Multicenter' },
    { label: '国内多中心', value: 'Internal_Multicenter' },
    { label: '国内单中心管理(区域负责)', value: 'Internal_Single' },
    { label: '不适用', value: 'Not_Applicable' },
];

class Filter extends Component {
    state = {
        areaList: [],
        stageList: [],
        contractTypeList: [],
        businessList: [],
        searchParams: {
            oper: "GE",
            planOper: 'LE'
        },
        expand: false,
    }

    componentDidMount() {
        const { jdeCode, investigationName } = this.props;
        const { searchParams } = this.state;
        searchParams.jdeCode = jdeCode;
        searchParams.investigationName = investigationName;
        this.setState({ searchParams }, () => {
            this.search();
        });
        this.loadTypeConfigureList();
        this.queryWithLevelByParams();
        this.queryAreaAll();
    }

    componentWillUnmount() {
        this.props.saveJdeCode('');
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { stageList, contractTypeList } = res;
            this.setState({
                stageList,
                contractTypeList,
            });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    queryAreaAll = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryAreaAll,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ areaList: res.data || [] });
            },
        };
        $.sendRequest(options);
    }

    reset = () => {
        this.props.saveJdeCode('');
        this.setState({
            searchParams: {
                oper: "GE",
                planOper: 'LE'
            },
        }, () => {
            this.search();
        });
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        switch (key) {
            case 'user':
            case 'pmLeader':
            case 'leaderUser':
            {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
            }
            case 'investigationGlobalType':
                searchParams[key] = value;
                searchParams.areaId = undefined;
                break;
            case 'stageIds':
                searchParams[key] = value ? value.join(',') : undefined;
                break;
            case 'lineOfBusiness': {
                searchParams[key] = value;
                searchParams.secondLineName = undefined;
            }
            default:
                searchParams[key] = value;
                break;
        }
        this.setState({ searchParams });
    }

    showFixedLine = () => {
        this.exportFixedLineRef.show();
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render() {
        const { canOverApply, exportAll, showTransfinite, showChangeLog } = this.props;
        const { expand, searchParams, areaList, stageList, contractTypeList, businessList } = this.state;
        const {
            oper,
            planOper,
            investigationCode,
            investigationName,
            stageIds,
            jdeCode,
            contractTypeId,
            investigationPlanEndTime,
            total1,
            acStatus,
            isRemark,
            isOnehundred,
            isManualAc,
            investigationGlobalType,
            userName,
            pmLeaderName,
            leaderUserName,
            lineOfBusiness,
        } = searchParams;
        const { curRole } = sessionStorage;
        const isBO = curRole == 'BO';
        const isPM = curRole == "PM";
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isPML = curRole == "PML";
        const isShow = isBO || isPM || isVP || isFIN;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const contractTypeListOption = contractTypeList.map(d => <Option key={String(d.typeConfigureId)}>{d.typeValue}</Option>);
        const stageOption = stageList.map(d => <Option key={String(d.typeConfigureId)}>{d.typeValue}</Option>);
        const globalTypeOption = GlobalTypeList.map(d => <Option key={d.value} value={d.value}>{d.label}</Option>);
        const areaOption = areaList.map(d => <Option key={d.areaId} value={d.areaId}>{d.areaName}</Option>);
        const maxHeight = expand ? 160 : 40;
        return (
            <div style={{marginBottom: 16}}>
                <div className="search-bar expand" style={{ maxHeight: maxHeight }}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目编号</label>
                        <Input
                            placeholder='请输入'
                            style={{ width: 140 }}
                            value={investigationCode}
                            onKeyPress={this.enterSearch}
                            onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目简称</label>
                        <Input
                            placeholder='请输入'
                            style={{ width: 140 }}
                            value={investigationName}
                            onKeyPress={this.enterSearch}
                            onChange={e => this.handleChange(e.target.value, 'investigationName')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目阶段</label>
                        <Select
                            className="multiple-stage"
                            mode="multiple"
                            placeholder="请选择"
                            filterOption={false}
                            style={{ width: 140 }}
                            value={stageIds ? stageIds.split(',') : []}
                            onChange={value => this.handleChange(value, 'stageIds')}
                        >
                            {stageOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE主项目号</label>
                        <Input
                            placeholder='请输入'
                            onKeyPress={this.enterSearch}
                            value={jdeCode}
                            onChange={e => this.handleChange(e.target.value, 'jdeCode')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">计收入确认方式</label>
                        <Select
                            placeholder='请选择'
                            style={{ width: 100 }}
                            value={contractTypeId}
                            onChange={value => this.handleChange(value, 'contractTypeId')}
                        >
                            {contractTypeListOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">PM</label>
                        <SearchRetrieve
                            keyword='keyword'
                            value={userName}
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            url={API_URL.sumtotal.queryAllInvestigationPm}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'user')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">PM主管</label>
                        <SearchRetrieve
                            keyword='keyword'
                            value={pmLeaderName}
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'pmLeader')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">领域leader</label>
                        <SearchRetrieve
                            keyword='leaderName'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={leaderUserName}
                            params={{ limit: 20, status: 'ALL' }}
                            url={API_URL.user.queryLeaderList}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'leaderUser')}
                        />
                    </div>
                    {
                        isShow &&
                        <div className="search-item">
                            <label className="ui-label">项目计划结束时间</label>
                            <InputGroup compact>
                                <Select value={planOper} style={{ width: 40 }} onChange={value => this.handleChange(value, 'planOper')}>
                                    <Option value="GE">&ge;</Option>
                                    <Option value="GT">&gt;</Option>
                                    <Option value="LT">&lt;</Option>
                                    <Option value="LE">&le;</Option>
                                    <Option value="EQ">=</Option>
                                </Select>
                                <MonthPicker
                                    style={{ width: 100 }}
                                    placeholder="请输入"
                                    format={monthFormat}
                                    value={investigationPlanEndTime ? moment(investigationPlanEndTime) : null}
                                    className="investigation_plan_end_time"
                                    onChange={(date, dateString) => this.handleChange(dateString, 'investigationPlanEndTime')}
                                />
                            </InputGroup>
                        </div>
                    }
                    {
                        isShow &&
                        <div className="search-item">
                            <label className="ui-label">Total1超限情况</label>
                            <InputGroup compact>
                                <Select value={oper} allowClear={true} style={{ width: 40 }} onChange={value => this.handleChange(value, 'oper')}>
                                    <Option value="GE">&ge;</Option>
                                    <Option value="GT">&gt;</Option>
                                    <Option value="LT">&lt;</Option>
                                    <Option value="LE">&le;</Option>
                                </Select>
                                <InputNumber
                                    min={0}
                                    precision={2}
                                    placeholder="请输入"
                                    style={{ width: 80 }}
                                    value={total1}
                                    onChange={value => this.handleChange(value, 'total1')}
                                />
                            </InputGroup>
                            <span style={{marginLeft: 4, lineHeight: '28px'}}>%</span>
                        </div>
                    }
                    {
                        isBO &&
                        <div className="search-item">
                            <label className="ui-label">AC自动调整功能</label>
                            <Select
                                allowClear={true}
                                placeholder='请选择'
                                style={{ width: 100 }}
                                value={acStatus}
                                onChange={value => this.handleChange(value, 'acStatus')}
                            >
                                <Option value="OPEN">已开启</Option>
                                <Option value="CLOSE">已关闭</Option>
                            </Select>
                        </div>
                    }
                    <div className="search-item">
                        <label className="ui-label">有无备注</label>
                        <Select
                            allowClear={true}
                            placeholder='请选择'
                            style={{ width: 100 }}
                            value={isRemark}
                            onChange={value => this.handleChange(value, 'isRemark')}
                        >
                            <Option value={1}>有</Option>
                            <Option value={0}>无</Option>
                        </Select>
                    </div>
                    {
                        isShow &&
                        <div className="search-item">
                            <label className="ui-label">当月完工是否达到100%</label>
                            <Select
                                allowClear={true}
                                placeholder='请选择'
                                style={{ width: 100 }}
                                value={isOnehundred}
                                onChange={value => this.handleChange(value, 'isOnehundred')}
                            >
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                    }
                    {
                        isShow &&
                        <div className="search-item">
                            <label className="ui-label">是否手动调整过AC</label>
                            <Select
                                allowClear={true}
                                placeholder='请选择'
                                style={{ width: 100 }}
                                value={isManualAc}
                                onChange={value => this.handleChange(value, 'isManualAc')}
                            >
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                    }
                    <div className="search-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusiness}
                            onChange={value => this.handleChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusiness}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目类型</label>
                        <Select
                            allowClear={true}
                            style={{ width: 170 }}
                            placeholder="请选择"
                            value={investigationGlobalType}
                            onChange={value => this.handleChange(value, 'investigationGlobalType')}
                        >
                            {globalTypeOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">区域</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            placeholder="请选择"
                            disabled={investigationGlobalType !== 'Internal_Single'}
                            value={searchParams.areaId}
                            onChange={value => this.handleChange(value, 'areaId')}
                        >
                            {areaOption}
                        </Select>
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.reset}>重置</Button>
                        <Button type="primary" onClick={exportAll}>导出</Button>
                        {(isBO || isVP || isFIN) && <Button onClick={this.showFixedLine} className="btn-yellow">导出固化数据</Button>}
                        {canOverApply && <Button onClick={showTransfinite} className="btn-yellow">超限申请</Button>}
                        {isBO && <Button onClick={showTransfinite} className="btn-yellow">超限管理</Button>}
                        {/* <Button onClick={showChangeLog} className='btn-green'>完工百分比变更日志</Button> */}
                        {
                            (!isShow && !isPML) &&
                            <Button onClick={() => history.go(-1)} className='btn-green'>返回</Button>
                        }
                    </div>
                </div>
                <ExportFixedLine ref={el => this.exportFixedLineRef = el} />
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    jdeCode: state.investigationState.jdeCode || '',
});

const mapDispatchToProps = (dispatch) => ({
    saveJdeCode: (jdeCode) => dispatch(saveJdeCode(jdeCode))
})

export default connect(mapSateToProps, mapDispatchToProps)(Filter);


// WEBPACK FOOTER //
// ./src/components/sumTotal/proPercent/Filter.js